import * as type from '@/store/types'


// Получение значения в state по заданному пути
export function getStateProperty(state, ref) {
  if (!ref) {
    throw Error(`State ref empty: ${ref}`)
  }

  const property = (Array.isArray(ref) ? ref : ref.split('.')).reduce(
    (prop, name) => (prop && prop[name] ? prop[name] : prop),
    state
  )

  if (property === state) {
    throw Error(`State property not found: ${ref}`)
  }

  return property
}

export function throwError(commit, title, message) {
  return (error) => {
    if (error && error.message === 'cancelled') return
    const status = error && error.response ? error.response.status : 0
    console.error('catchError', status, title, error ? error.response : '', error)
    commit(type.ERROR, { title, message, error })
    throw error || new Error(message)
  }
}
